import { AnalyticService } from '@app/teacher/services/analytic.service';
import { PeopleService } from '@app/core/services';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs/internal/Subject';
import { School } from '@app/definitions/interfaces';
import { HandlerService } from '@app/_services/handler.service';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit, OnDestroy {
    private destroy$: Subject<boolean> = new Subject<boolean>();
    reportsForm: FormGroup;
    schools: Array<School> = [];

    reportsAccess: boolean = true;
    schoolsNotFound: boolean = false;

    constructor(
        private _formBuilder: FormBuilder,
        private handlerService: HandlerService,
        private peopleService: PeopleService,
        private analyticsService: AnalyticService
    ) {}

    ngOnInit(): void {
        this.initForm();
        this.getSchools();
    }

    private initForm(): void {
        this.reportsForm = this._formBuilder.group({
            reportsType: ['1', []],
            schoolId: [null, []],
            startLearnDate: [new Date(), []],
            endLearnDate: [new Date(), []],
            email: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(35), Validators.email]]
        });
    }

    private getSchools(): void {
        const groupRights = JSON.parse(localStorage.getItem('groupRights'));
        if (!groupRights.access_for_reports.is_access) {
            this.reportsAccess = false;
            return;
        }
        this.peopleService.getProfileSchools().subscribe(resp => {
            console.log(resp);
            this.schools = resp || [];

            if (this.schools.length === 0) {
                this.schoolsNotFound = true;
                return;
            }

            this.reportsForm.patchValue({
                schoolId: this.schools[0].id
            });
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    onSubmit(): void {
        if (this.reportsForm.valid) {
            const requestData = this.reportsForm.value;

            this.analyticsService.createReportsCSVdata(requestData).subscribe(resp => {
                if (resp.success) {
                    const msg = 'Запрос успешно отправлен';
                    this.handlerService.successMsg(msg, 3000);
                }
            });
        }
    }
}
